"use client";
import { DrupalNode } from "next-drupal";
import React from "react";
import { motion } from "framer-motion";
import Banner from "@/components/sections/Banner";

interface termsConditionProps {
  pageData: DrupalNode;
}

const TermsConditionScreen: React.FC<termsConditionProps> = ({ pageData }) => {
  const { title = "", field_terms_condition_content = {} } = pageData;
  return (
    <div className="pt-20">
      <Banner
        title={title}
        isRounded
        backgroundImg="/static/images/terms-conditions-banner.webp"
      />
      <div className="py-12 bg-mapGray relative overflow-hidden">
        <div className="mini-container relative z-[2]">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 0,
            }}
            className="remove-animation-fluctuation terms-page-text text-base text-[#003350] --font-poppins leading-normal mb-5 !text-left mobileMax:text-xsmall mobileMax:leading-normal"
            dangerouslySetInnerHTML={{
              __html: field_terms_condition_content?.value,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TermsConditionScreen;
